import React from "react";

import { components } from "react-select";

import type { DropdownIndicatorProps } from "react-select";

import { DenovoIcon } from "../../icons";
import { IOption } from "../interfaces";

export const DropdownIndicator: React.FC<DropdownIndicatorProps<IOption>> = (
  props,
) => {
  const { selectProps } = props;

  return (
    <components.DropdownIndicator {...props}>
      <DenovoIcon
        icon="chevron-down"
        className={`text-contentSecondary transition-transform duration-200 ${
          selectProps.menuIsOpen ? "rotate-180" : ""
        }`}
      />
    </components.DropdownIndicator>
  );
};
